<ng-template
  let-extraClass="extraClass"
  #topNav
>
  <tidy-top-nav
    [class]="extraClass"
    [canGoBack]="true"
    [customBack]="'introduction'"
    [title]="'Capacitor ' + capacitorVersion + ' Test'">
  </tidy-top-nav>
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }"></ng-container>

<ng-template #content>
  <tidy-wrapper>
    <ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }"></ng-container>

    <tidy-card>
      <tidy-row>
        <tidy-text
          [title]="'Android 15 (API 35) Test Page'">
        </tidy-text>
      </tidy-row>

      <tidy-row>
        <tidy-text
          [body]="'Test all Capacitor 7 native features after the big update to Android 15 (API level 35).'">
        </tidy-text>
      </tidy-row>

      <tidy-row class="extra-bottom-padding">
        <tidy-divider></tidy-divider>
      </tidy-row>

      <tidy-row>
        <tidy-button
          [text]="isRunning ? 'Running Tests...' : 'Run All Auto Tests'"
          [action]="runAllTests.bind(this)"
          [disabled]="isRunning"
          class="primary">
        </tidy-button>
      </tidy-row>

      <tidy-row>
        <tidy-text [header]="'Test Results'"></tidy-text>
      </tidy-row>

      <tidy-grid>
        <tidy-row *ngFor="let test of testResults">
          <ion-card [color]="getStatusColor(test.status)">
            <ion-card-header>
              <ion-card-title>
                {{ getStatusIcon(test.status) }} {{ test.name }}
              </ion-card-title>
            </ion-card-header>
            <ion-card-content>
              <p>{{ test.message }}</p>
              <div *ngIf="test.data" style="font-size: 12px; margin-top: 8px; opacity: 0.8;">
                <pre style="white-space: pre-wrap; word-wrap: break-word;">{{ test.data | json }}</pre>
              </div>
            </ion-card-content>
          </ion-card>
        </tidy-row>
      </tidy-grid>

      <tidy-row class="extra-bottom-padding">
        <tidy-divider></tidy-divider>
      </tidy-row>

      <tidy-row>
        <tidy-text [header]="'Manual Tests'"></tidy-text>
      </tidy-row>

      <tidy-row>
        <tidy-text
          [body]="'These tests require user interaction:'">
        </tidy-text>
      </tidy-row>

      <tidy-row>
        <tidy-button
          [text]="'Test Geolocation'"
          [action]="testGeolocation.bind(this)"
          class="secondary">
        </tidy-button>
      </tidy-row>

      <tidy-row>
        <tidy-button
          [text]="'Test Camera'"
          [action]="testCamera.bind(this)"
          class="secondary">
        </tidy-button>
      </tidy-row>

      <tidy-row>
        <tidy-button
          [text]="'Test File Picker'"
          [action]="testFilePicker.bind(this)"
          class="secondary">
        </tidy-button>
      </tidy-row>

      <tidy-row>
        <tidy-button
          [text]="'Test Share'"
          [action]="testShare.bind(this)"
          class="secondary">
        </tidy-button>
      </tidy-row>

      <tidy-row>
        <tidy-button
          [text]="'Test Browser'"
          [action]="testBrowser.bind(this)"
          class="secondary">
        </tidy-button>
      </tidy-row>

      <tidy-row class="extra-bottom-padding">
        <tidy-text
          [body]="'Secret debug page unlocked by clicking the logo 5 times on the introduction screen.'">
        </tidy-text>
      </tidy-row>

    </tidy-card>
  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper [templateContent]="content"></app-scroll-wrapper>
